module.exports = __webpack_public_path__ + "static/img/eko-energy.ba440c1e.png";